import { gql } from "@apollo/client";

const createCustomsShipmentMutation = gql`
  mutation ($direction: CustomsShipmentDirection!) {
    createCustomsShipment(direction: $direction) {
      createdCustomsShipment {
        id
      }
      errors {
        direction
      }
      succeeded
    }
  }
`;

export default createCustomsShipmentMutation;
